const LOADER_CALL = ["load1"];

export const useLoader = ({textLoader}) => {
    
    textLoader = textLoader ? textLoader : "";
    
    const showLoader = () => {
        const loader = document.getElementById("loader");
        if(loader){
            loader.classList.remove("none");
            loader.classList.add("loaderIP4");
            const text = loader.querySelector(".text-loader");
            if(text){
                text.innerHTML = textLoader;
            }
            LOADER_CALL.push(`load${(LOADER_CALL.length+1)}`);
        }
    }

    const showSolidLoader = () => {

        const loader = document.getElementById("loader");
        if(loader){
            loader.classList.remove("none");
            loader.classList.remove("loaderIP4");
            const text = loader.querySelector(".text-loader");
            if(text){
                text.innerHTML = "";
            }
            LOADER_CALL.push(`load${(LOADER_CALL.length+1)}`);
        }

    }

    const hideLoader = () => {
        const loader = document.getElementById("loader");
        if(loader && LOADER_CALL.length <= 1){
            loader.classList.add("none");
            loader.classList.remove("loaderIP4");
            const text = loader.querySelector(".text-loader");
            if(text){
                text.innerHTML = "";
            }
        }
        LOADER_CALL.pop();
        
    }

    return {showLoader, hideLoader, showSolidLoader};

}